const fmtHora = (hhmm = '') => {
  const [h, m] = hhmm.split(':');
  return `${Number(h)}h${m && m !== '00' ? m : ''}`;
};

export const rotuloDoIntervalo = (i) => `${fmtHora(i.horarioInicial)} - ${fmtHora(i.horarioFinal)}`;

const paraHHMM = (h, m) => `${String(h).padStart(2, '0')}:${m || '00'}`;

// "6h - 8h" -> { horarioInicial: "06:00", horarioFinal: "08:00" }; null se não reconhecido.
export const rotuloParaIntervalo = (rotulo) => {
  const m = typeof rotulo === 'string'
    ? rotulo.match(/^\s*(\d{1,2})h(\d{2})?\s*-\s*(\d{1,2})h(\d{2})?\s*$/)
    : null;
  return m ? { horarioInicial: paraHHMM(m[1], m[2]), horarioFinal: paraHHMM(m[3], m[4]) } : null;
};

// Pontos ainda sem intervalosDeHorario usam os rótulos antigos de `horarios`.
export const intervalosDoPonto = (ponto) => {
  if ((ponto.intervalosDeHorario || []).length) return ponto.intervalosDeHorario;
  return (ponto.horarios || []).map(rotuloParaIntervalo).filter(Boolean);
};

// Minutos desde 00:00 do início de um rótulo como "6h - 8h" ou "6h30 - 8h"; null se não reconhecido.
export const inicioEmMinutos = (rotulo) => {
  const m = typeof rotulo === 'string' ? rotulo.match(/^\s*(\d{1,2})h(\d{2})?/) : null;
  return m ? Number(m[1]) * 60 + Number(m[2] || 0) : null;
};

export const chavePeriodoDoRotulo = (rotulo) => {
  const inicio = inicioEmMinutos(rotulo);
  if (inicio === null) return null;
  if (inicio < 12 * 60) return 'manha';
  if (inicio < 18 * 60) return 'tarde';
  return 'noite';
};

const ordenar = (lista) => [...lista].sort((a, b) => (inicioEmMinutos(a) ?? 0) - (inicioEmMinutos(b) ?? 0));

// Separa os rótulos em manhã/tarde/noite; `extras` mantém horários já selecionados que saíram do cadastro do ponto.
export const opcoesDeHorarioDoPonto = (ponto, extras = []) => {
  const base = ponto
    ? ((ponto.intervalosDeHorario || []).length
      ? ponto.intervalosDeHorario.map(rotuloDoIntervalo)
      : (ponto.horarios || []))
    : [];
  const todos = Array.from(new Set([...base, ...extras]));
  const opcoes = { manha: [], tarde: [], noite: [] };
  todos.forEach((rotulo) => {
    const chave = chavePeriodoDoRotulo(rotulo);
    if (chave) opcoes[chave].push(rotulo);
  });
  return { manha: ordenar(opcoes.manha), tarde: ordenar(opcoes.tarde), noite: ordenar(opcoes.noite) };
};
